import { Item } from '@ui/shared/util-api';

export class ListItem extends Item {}
